import React, { useState } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import Icons from '../../../../../components/Icons/Icons';
import InfoPopup from '../../../../../components/InfoPopup/InfoPopup';
import GuidePopup from '../../../../../components/GuidePopup/GuidePopup';

import '../../../../../styles/react-tooltip.css';
import css from './SignatureServices.module.css';
import { TALENT_SERVICES_GUIDES } from '../../../../../util/enums';

const creativeMediaOptions = [
  { title: 'Audio Creation', guide: TALENT_SERVICES_GUIDES.AUDIO_RECORDING },
  { title: 'Behind-the-Scenes Video', guide: TALENT_SERVICES_GUIDES.BEHIND_THE_SCENES_VIDEO },
  { title: 'Custom Articles', guide: TALENT_SERVICES_GUIDES.CUSTOM_ARTICLES },
  {
    title: 'Fitness Demonstration Video',
    guide: TALENT_SERVICES_GUIDES.FITNESS_DEMONSTRATION_VIDEO,
  },
  { title: 'How-To Video', guide: TALENT_SERVICES_GUIDES.HOW_TO_VIDEO },
  { title: 'Photo Creation', guide: TALENT_SERVICES_GUIDES.PHOTO_CREATION },
  { title: 'Podcast Clip', guide: TALENT_SERVICES_GUIDES.PODCAST_CLIP },
  { title: 'Product Testing', guide: TALENT_SERVICES_GUIDES.PRODUCT_TESTING_VIDEO },
  { title: 'Unboxing Video', guide: TALENT_SERVICES_GUIDES.UNBOXING_VIDEO },
  { title: 'Video Creation with Audio', guide: TALENT_SERVICES_GUIDES.VIDEO_CREATION_WITH_AUDIO },
  { title: 'Voiceover Recording', guide: TALENT_SERVICES_GUIDES.VOICEOVER_RECORDING },
].sort((a, b) => a.title.localeCompare(b.title));

const appearanceTooltips = {
  'Product Testing': 'Create custom videos testing and reviewing products.',
  'Photo Creation': 'Create and share unique photos featuring products or brands.',
  'Video Creation with Audio': 'Craft custom videos with audio to highlight brands or messages.',
  'Audio Creation': 'Record unique audio for branding or special projects.',
  'Unboxing Video': 'Film engaging unboxings of products.',
  'Custom Articles':
    'Craft tailored written content to enhance branding, engage audiences, and support marketing initiatives.',
  'How-To Video': 'Create custom instructional videos demonstrating products or skills.',
  'Voiceover Recording': "Provide professional voiceovers for clients' projects.",
  'Podcast Clip': "Record short podcast-style audio clips discussing topics of clients' choice.",
  'Behind-the-Scenes Video': 'Create exclusive behind-the-scenes content for brands.',
  'Fitness Demonstration Video': 'Create workout or sports training videos for clients.',
};

const CreativeMedia = ({ values }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = index => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const faqsData = [
    {
      question: 'Creative Media',
      answer: (
        <div className={css.appearancesFormRow}>
          {creativeMediaOptions.map((option, index) => (
            <React.Fragment key={index}>
              <div className={css.formFld}>
                <label className={css.talentOptions}>
                  <Field
                    name={`creativeMedia[${index}].selected`}
                    component="input"
                    type="checkbox"
                    format={Boolean}
                    parse={Boolean}
                  />
                  <span>
                    {option.title}
                    {appearanceTooltips[option.title] && (
                      <InfoPopup triggerOn="hover" info={appearanceTooltips[option.title]} />
                    )}
                    <GuidePopup externalLink={option.guide} />
                  </span>
                </label>

                <Field name={`creativeMedia[${index}].selected`} subscription={{ value: true }}>
                  {({ input }) =>
                    input.value && (
                      <div className={css.customFldSec}>
                        <span className={css.currency}>$</span>
                        <Field
                          name={`creativeMedia[${index}].price`}
                          component="input"
                          className={css.input}
                          type="number"
                          placeholder={`Hourly Price for ${option.title}`}
                        />
                        <span className={css.price}>.00</span>
                      </div>
                    )
                  }
                </Field>
              </div>

              <Field
                name={`creativeMedia[${index}].title`}
                component="input"
                type="hidden"
                initialValue={option.title}
              />
            </React.Fragment>
          ))}
        </div>
      ),
    },
  ];

  return (
    <>
      {faqsData.map((faq, index) => (
        <div
          key={index}
          className={classNames(css.faqCard, {
            [css.activeFAQ]: activeIndex === index,
          })}
          onClick={() => handleAccordionClick(index)}
        >
          <div className={css.faqBody}>
            <span className={css.faqHeading}>
              {faq?.question}
              <span className={css.faqIcon}>
                {activeIndex === index ? <Icons name="upAngle" /> : <Icons name="downAngle" />}
              </span>
            </span>
            {activeIndex === index && (
              <div className={css.faqDescription} onClick={e => e.stopPropagation()}>
                {faq?.answer}
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export default CreativeMedia;
